export default __webpack_public_path__ + "static/media/itech.d6e278a8.png";